import { PlaceActionType } from './place-action-type';

export interface LoadPlaceRequestAction {
  placeKey: string;
  type: PlaceActionType.LoadPlaceRequest;
}

export const loadPlaceRequest = (placeKey: string): LoadPlaceRequestAction => ({
  placeKey,
  type: PlaceActionType.LoadPlaceRequest,
});
